import { render, staticRenderFns } from "./ServiceProducts.vue?vue&type=template&id=37c2024e"
import script from "./ServiceProducts.vue?vue&type=script&lang=ts"
export * from "./ServiceProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports